@if (servicePlan && hasContentForFeatureSection) {
  <h3 class="d-none d-sm-block heading__regular--l mb-0">
    {{ servicePlan.description ? servicePlan.description : servicePlan.name }}
  </h3>
  <div class="d-none d-sm-block w-100 separator my-4"></div>
  @if (servicePlan.features?.length) {
    <dcp-checkmark-list [entries]="servicePlan.features"></dcp-checkmark-list>
  }
  @if (includedList?.length) {
    @if (servicePlan.features?.length) {
      <div class="w-100 separator my-4"></div>
    }
    <dcp-checkmark-list [entries]="includedList"></dcp-checkmark-list>
  }
  @if (commitmentPeriod || restrictions?.length) {
    @if (servicePlan.features?.length || includedList?.length) {
      <div class="w-100 separator my-4"></div>
    }
    <dcp-checkmark-list
      [entries]="
        mergeArrays(
          commitmentPeriod
            ? [
                {
                  value:
                    (durationTranslationKey
                    | cxTranslate
                      : {
                          min: commitmentPeriod.min?.toString(10),
                          max: commitmentPeriod.max?.toString(10),
                          unit: commitmentPeriod.unit?.name,
                        }),
                },
              ]
            : undefined,
          restrictions
        )
      "
      [useBoxIcon]="true"></dcp-checkmark-list>
  }
}
@if (termsConditionsProductEntries.length) {
  <div class="w-100 separator my-4"></div>
  <dcp-terms-conditions
    [entry]="termsConditionsProductEntries[0]"
    [entries]="termsConditionsProductEntries"
    [pdpTerms]="{isPdpTerms: true, showIconLink: false}"
    [isStoreHeaderShown]="true"
    (termsConditionsLoadedNoData)="onNoEntryData($event)">
  </dcp-terms-conditions>
}
